import { IFeatureState } from './state.interface';

// type TStateMutation = Pick<IFeatureState<unknown, unknown>, 'model' | 'data'>;

type TStateMutation<IFeatureState> = {
  [Property in keyof IFeatureState]: any;
};

export class StateBuilder<T extends IFeatureState<unknown, unknown>> {
  private _mutation: Partial<T>;
  private _state: T;

  constructor(state: T, mutation?: Partial<T>) {
    this._state = { ...state };
    this._mutation = { ...mutation };
    return this;
  }

  build(): T {
    return {
      ...this._state,
      ...this._mutation
    };
  }

  toError(error: any = {}) {
    this.mutateError(error);
    return this;
  }

  toLoading() {
    // this.mutateUiState({
    //   loading: true,
    //   loaded: false
    // });
    return this;
  }
  toLoaded() {
    // this.mutateUiState({
    //   loading: false,
    //   loaded: true
    // });
    return this;
  }

  private mutateError(mutation: any) {
    const { error } = this._state as IFeatureState<unknown, unknown>;
    this._state = {
      ...this._state,
      ...{ error: { ...mutation } }
    };
  }

  // private mutateUiState(mutation: Partial<IFeatureUiState>) {
  //   const { uiState } = this._state as IFeatureState<unknown, unknown>;
  //   this._state = {
  //     ...this._state,
  //     ...{
  //       uiState: {
  //         ...uiState,
  //         ...mutation
  //       }
  //     }
  //   };
  // }
}
